import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"variable\":\"--font-roboto\",\"weight\":[\"400\",\"900\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/(pages)/components/Banner/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/(pages)/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/(pages)/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/context/UserContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/Main.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/styles/reset.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/styles/fontIcon.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/Master/SDialogFC/DialogPortal.tsx");
